import { LongSelect } from "components/base/Form";

export const TODO_DATE_RANGE_OPTIONS = [
  { days: 7, label: "7天前起" },
  { days: 30, label: "30天前起" },
  { days: 60, label: "60天前起" },
  { days: 90, label: "90天前起" },
];

const TodoDateRangeSelect = ({
  days,
  disabled,
  onChange,
  options = TODO_DATE_RANGE_OPTIONS,
}) => (
  <LongSelect
    className="w-22 shrink-0 text-xs"
    disabled={disabled}
    onChange={onChange}
    options={options.map((option) => ({
      value: option.days,
      label: option.label,
    }))}
    value={days}
  />
);

export default TodoDateRangeSelect;
